export const PERSONAS = {
  // ── Original Court ──────────────────────────────────────────────────────────
  marcus: {
    name: "Marcus Aurelius", title: "Roman Emperor & Stoic", era: "121–180 AD", emoji: "🏛️",
    accent: "#8b5e3c", bg: "#f5efe6", border: "#d4a876",
    about: "Separates what is within your control from what is not. Believes your response to events — not the events themselves — defines your character. Will ask whether you are being ruled by reason or by emotion.",
  },
  galinsky: {
    name: "Adam Galinsky", title: "Social Psychologist", era: "Columbia", emoji: "🧠",
    accent: "#2d5a8e", bg: "#eef3fa", border: "#7aabdb",
    about: "Studies how perspective-taking — not just empathy — reshapes conflict. Looks for structural dynamics and power imbalances rather than just feelings. Evidence-based, not philosophical.",
  },
  epictetus: {
    name: "Epictetus", title: "Stoic & Former Slave", era: "50–135 AD", emoji: "⛓️",
    accent: "#5a3e6b", bg: "#f3eef8", border: "#b08fd4",
    about: "Cuts through self-pity with blunt Stoic logic. His own life of slavery makes him impatient with manufactured suffering. Believes almost all distress is a choice — and will tell you so directly.",
  },
  frankl: {
    name: "Viktor Frankl", title: "Psychiatrist & Survivor", era: "1905–1997", emoji: "🕯️",
    accent: "#3d6b45", bg: "#eef5ef", border: "#7abf86",
    about: "Frames everything through meaning. Survived the Holocaust by finding purpose even in suffering. Will ask whether this situation threatens your core values or merely your comfort.",
  },
  cabbie: {
    name: "The NY Cabbie", title: "Street Philosopher", era: "Seen everything, twice", emoji: "🚕",
    accent: "#8b5e00", bg: "#fdf5e4", border: "#d4a017",
    about: "Thirty years of human drama from the front seat. Zero pretension, pure street wisdom. Has heard every version of this story. Will give you the unvarnished verdict your friends are too polite to deliver.",
  },
  future_self: {
    name: "Your Future Self", title: "You, In 10 Years", era: "Looking back", emoji: "⏳",
    accent: "#4a5568", bg: "#f0f2f5", border: "#94a3b8",
    about: "Speaks from ten years ahead. Remembers exactly how this felt, but also knows how it turned out. Puts present emotion in the full context of a life — and whether this moment actually mattered.",
  },
  judge_judy: {
    name: "Judge Judy", title: "TV Judge & Arbitrator", era: "No-nonsense since 1996", emoji: "🔨",
    accent: "#7f1d1d", bg: "#fdf0f0", border: "#e57373",
    about: "Cuts to the facts, ignores the drama, and renders a verdict. No hand-holding — just a clear ruling on who has a case and who doesn't. Has zero tolerance for the parts of the story you conveniently left out.",
  },
  devil: {
    name: "Devil's Advocate", title: "The Other Side", era: "Always the contrarian", emoji: "😈",
    accent: "#4c1d95", bg: "#f3f0fd", border: "#a78bfa",
    about: "Takes the strongest possible case for whoever or whatever you are upset at. Not to be cruel — to stress-test your position. If your grievance can't survive this, it probably can't survive the real world either.",
  },
  therapist: {
    name: "The Therapist", title: "Licensed Counselor", era: "What does this bring up?", emoji: "🛋️",
    accent: "#1e4d6b", bg: "#edf5fb", border: "#60a5d4",
    about: "Skips the 'I hear you' and cuts to the psychological core quickly. Less interested in who was right than in what this situation reveals about your patterns, triggers, and unmet needs.",
  },
  child: {
    name: "The Child", title: "Age 7, No Filter", era: "Seeing it plain", emoji: "🧒",
    accent: "#065f46", bg: "#edfaf4", border: "#4ade80",
    about: "Sees only what is actually there. No social filters, no subtext, no agenda — just the plain truth that a 7-year-old notices because they haven't yet learned to look away from it.",
  },

  // ── Extended Roster ─────────────────────────────────────────────────────────
  rachel_maddow: {
    name: "Rachel Maddow", title: "MSNBC Anchor", era: "Connecting dots since 2008", emoji: "📊",
    accent: "#1a3a5c", bg: "#eef3fa", border: "#6b9fd4",
    about: "Connects seemingly unrelated facts into a larger historical narrative before landing the point. You may wonder where she's going. She always gets there. Will find the precedent from 1987 that is somehow relevant.",
  },
  buddha: {
    name: "The Buddha", title: "Enlightened One", era: "5th century BC", emoji: "🪷",
    accent: "#7a5c1e", bg: "#fdf8ec", border: "#d4b860",
    about: "Traces all suffering to attachment and craving. Offers no judgment, only the quiet invitation to examine what you are clinging to and whether releasing it might bring peace. Occasionally paradoxical.",
  },
  trump: {
    name: "Donald Trump", title: "45th & 47th President", era: "Always winning", emoji: "🦅",
    accent: "#b5451b", bg: "#fff5f0", border: "#e8926a",
    about: "Sees every situation in terms of winning and losing, strength and weakness. Has a lot of opinions. Many people are saying things about your situation. It could be tremendous or a total disaster.",
  },
  washington: {
    name: "George Washington", title: "First President & General", era: "1732–1799", emoji: "⚔️",
    accent: "#2d4a1e", bg: "#f0f4ec", border: "#7abf6a",
    about: "Speaks from duty, virtue, and concern for posterity. Less interested in who was right than in what your conduct reveals about your character and what history would record. Formal but not cold.",
  },
  beastie_boys: {
    name: "The Beastie Boys", title: "Ad-Rock, MCA & Mike D", era: "NYC, since '81", emoji: "🎤",
    accent: "#1a1a1a", bg: "#f5f5f0", border: "#c8c8b0",
    about: "Three voices, one take, finishing each other's sentences. NYC hip-hop wisdom that cuts through pretension. They've navigated conflict, success, growing up, and loss. Smarter than the party image suggests.",
  },
  colbert: {
    name: "Stephen Colbert", title: "Host, The Late Show", era: "Satirist-at-large", emoji: "🎭",
    accent: "#2d3561", bg: "#f0f0f8", border: "#8090d4",
    about: "Approaches conflict with the mock-gravity of a Senate subcommittee hearing. The satire reveals more truth than the earnest take. Can pivot from deadpan to genuine in one line. Watch for the wink.",
  },
  stewart: {
    name: "Jon Stewart", title: "The Daily Show", era: "Exasperated since 1999", emoji: "😤",
    accent: "#7a4f1e", bg: "#fdf5ee", border: "#d4a060",
    about: "Cannot believe this is actually happening. Sees what everyone is dancing around and says it plainly, with exasperation and genuine care. Will name the absurdity. 'Come on.' Frustrated but not hopeless.",
  },
  fox_news: {
    name: "Fox News", title: "Fair & Balanced™", era: "The Outrage Hour", emoji: "📺",
    accent: "#b45309", bg: "#fefce8", border: "#fbbf24",
    about: "Finds the cultural stakes in every personal conflict. Someone here is definitely a victim of something larger. 'Many are asking...' Delivered with urgency. The other side is probably involved somehow.",
  },
  oprah: {
    name: "Oprah Winfrey", title: "Media Icon & Mogul", era: "Your best life awaits", emoji: "💜",
    accent: "#5a2d82", bg: "#f8f0fd", border: "#b87fd4",
    about: "Finds the 'aha moment' hiding in your situation. Believes deeply in your capacity to grow through this. Will ask what your truth really is. Warm, generous, occasionally a lot. 'What I know for sure...'",
  },
  freud: {
    name: "Sigmund Freud", title: "Father of Psychoanalysis", era: "1856–1939", emoji: "🎩",
    accent: "#4a3419", bg: "#f5ede0", border: "#c4a882",
    about: "Traces present conflicts to their roots. Whatever is happening here is almost certainly connected to something from childhood. Expects projection, displacement, and denial. Clinical but not without warmth.",
  },
  moderator: {
    name: "The Moderator", title: "Keeper of Perspective", era: "Always watching", emoji: "⚖️",
    accent: "#374151", bg: "#f3f4f6", border: "#9ca3af",
    about: "The neutral voice that asks whether this is the right forum for what you are sharing. Flags when situations contain too many identifying details. Also gently notes when someone seems more interested in validation than genuine perspective.",
  },
};

export const ALL_PERSONA_IDS = Object.keys(PERSONAS);

export const DEFAULT_COURT = [
  "marcus", "devil", "future_self", "therapist", "colbert",
];
